// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { SpeedInsights } from '@vercel/speed-insights/react';
import App from './App';
import registrarServiceWorker from './offline/registrarSW';
// Se importa acá y no dentro de una pantalla: el navegador dispara
// `beforeinstallprompt` apenas carga la página, y si nadie lo está escuchando
// en ese momento se pierde para siempre. Ver offline/instalacion.js.
import './offline/instalacion';
import { avisarActualizacionDisponible } from './offline/actualizaciones';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('No se encontró el elemento root para inicializar la aplicación.');
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
    <SpeedInsights />
  </React.StrictMode>
);

// Habilita la instalación como app y el arranque sin conexión. Sólo hace algo
// en producción y sobre HTTPS (o localhost): ver offline/registrarSW.js.
registrarServiceWorker({ alHaberVersionNueva: avisarActualizacionDisponible });
